import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Main from "../../layouts/Main";
import Card from "../../components/Card";
import Loader from "../../components/Loader";
import Button from "../../components/Button";
import InputGroup from "../../components/InputGroup";
import Pagination from "../../components/Pagination";
import WorkerService from "../../services/Worker";
import ParameterService from "../../services/Parameter";
import MasterBpjsService from "../../services/MasterBpjs";
import WorkerItem from "./WorkerItem";
import Bpjs from "./modal/Bpjs";
import Deposit from "./modal/Deposit";
import { Toast } from "../../config/Toast";
import "jsoneditor-react/es/editor.min.css";

const WorkerList = () => {
  const [workers, setWorkers] = useState();
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [masterBpjs, setMasterBpjs] = useState(0);
  const [data, setData] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState(null);
  const [totalPage, setTotalPage] = useState(0);
  const limit = 10;
  const notifySucces = (message) => toast.success(message, Toast);
  const notifyFailed = (message) => toast.error(message, Toast);

  const getLocalStorage = (key) => {
    const localStorageData = localStorage.getItem(key);
    return localStorageData ? JSON.parse(localStorageData) : null;
  };

  const users = getLocalStorage("rms") || { id: 0 };

  // Modal
  const [activeModal, setActiveModal] = useState({
    confirm: false,
    bpjs: false,
    bpjsEdit: false,
    deposit: false,
  });
  const openModal = (name) => setActiveModal((prev) => ({ ...prev, [name]: true }));
  const closeModal = (name) => setActiveModal((prev) => ({ ...prev, [name]: false }));

  // Fetch Master BPJS
  useEffect(() => {
    const fetchMasterBpjs = async () => {
      try {
        const { data } = await MasterBpjsService.list();
        setMasterBpjs(data.data.amount);
      } catch (err) {
        console.error("Master BPJS error:", err);
        notifyFailed("Gagal memuat data master BPJS");
      }
    };

    fetchMasterBpjs();
  }, []);

  // Fetch Worker List
  useEffect(() => {    
    setLoading(true);

    WorkerService.list(pageNumber, limit, search)
      .then((res) => {
        setWorkers(res.data.data);
        setTotalPage(res.data.total_page);
      })
      .catch((err) => {
        console.log(err);
      })

    setLoading(false);
  }, [refresh, pageNumber, search]);

  const syncWorkerHandler = () => {
    setBtnLoading(true);

    ParameterService.syncWorkers()
      .then(() => {
        setRefresh(prev => !prev);
        setBtnLoading(false);
        notifySucces(`Sync data tukang berhasil`);
      })
      .catch((err) => {
        console.log(err);
        setBtnLoading(false);
        notifyFailed("Gagal sync data tukang");
      });
  };
  const searchHandler = (value) => {
    setPageNumber(1);
    setSearch(value);
  };
  const changePageHandler = ({ selected }) => {
    setPageNumber(selected + 1);
  };

  const handleModalDeposit = (data) => {
    setData(data);
    openModal("deposit");
  }
  const handleDepositTransaction = async (id, data) => {
    const payload = { ...data, processed_by: users.id };

    try {
      const result = await WorkerService.deposit(id, payload);
      setRefresh(prev => !prev);
      closeModal("deposit");
      notifySucces(result.data.message);
    } catch (err) {
      closeModal("deposit");
      notifyFailed(err.response.data.message || "Gagal melakukan transaksi deposit");
    }
  }

  const handleModalBpjs = (data) => {
    setData(data);
    openModal("bpjs");
  }
  const handleBpjsTransaction = async (id, data) => {
    const payload = { ...data, processed_by: users.id };

    try {
      const result = await WorkerService.bpjsUpdate(id, payload);
      setRefresh(prev => !prev);
      notifySucces(result.data.message);
      return { success: true, deposit: result.data.data.deposit_balance };
    } catch (err) {
      notifyFailed(err.response.data.message || "Gagal melakukan transaksi BPJS");
      return { success: false };
    }
  }

  if (loading === true) {
    return <Loader />;
  }

  return (
    <Main title="List Worker">

      {activeModal.bpjs && <Bpjs data={data} masterBpjs={masterBpjs} activeModal={activeModal.bpjs} submitBpjsHandler={handleBpjsTransaction} closeModal={() => closeModal("bpjs")} />}

      {activeModal.deposit && <Deposit data={data} onSubmit={handleDepositTransaction} activeModal={activeModal.deposit} closeModal={() => closeModal("deposit")} />}

      <Card col={"col-xl-12 col-lg-12"}>
        <div className="row mb-4">
          <div className="col">
            <Button
              button="btn-orange"
              title="Sync"
              icon="fa fa-exchange me-2"
              onClick={syncWorkerHandler}
              loading={btnLoading}
            />
          </div>
          <div className="col">
            <InputGroup button="btn-primary" icon="fa fa-search" placeholder="Search Name / Email / Bank Number / Bank Account Name" searchHandler={searchHandler} />
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-12">
            <div className="table-responsive">
              <table className="table table-bordered text-nowrap text-md-nowrap text-center mb-0">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Bank</th>
                    <th>Bank Account Name</th>
                    <th>Bank Number</th>
                    <th>Email</th>
                    <th>Deposit</th>
                    <th>BPJS</th>
                  </tr>
                </thead>
                <tbody>
                  {workers &&
                    workers.map((worker, index) => (
                      <WorkerItem
                        key={workers.id}
                        no={index + (pageNumber === 1 ? 1 : limit * pageNumber - limit + 1)}
                        data={worker}
                        type="Deposit Awal"
                        handleDeposit={handleModalDeposit}
                        handleBpjs={handleModalBpjs}
                      />
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col">{totalPage > 0 && <Pagination pageCount={totalPage} forcePage={pageNumber - 1} changePage={changePageHandler} />}</div>
        </div>
      </Card>
    </Main>
  );
};

export default WorkerList;
